import React, { Suspense, useCallback } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useSelector } from 'react-redux';
import { queryClient } from './query-client';

//  MUI theme config
import { StyledEngineProvider } from '@mui/material/styles';

import { FlagsProvider } from './Features/FeatureFlags';
import Features from './Features/Features';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import LoadingIndicator from './components/LoadingIndicatorMaterial/LoadingIndicator';
import Root from './Routing/Layouts/RootLayout/Root';
import ErrorModal from './components/3.0/Modals/ErrorModal/ErrorModal';
import { resetErrorModalMessage } from './redux/ErrorModal/error-modal-redux-slice';
import { useAppDispatch } from './redux/store';
import AppWarningModalWithDetails from '@3.0/Modals/WarningModal/AppWarningModalWithDetails';

function App() {
  const dispatch = useAppDispatch();
  const errorMessage = useSelector((state) => state.errorModal.errorMessage);
  const handleErrorModalClose = useCallback(() => dispatch(resetErrorModalMessage()), [dispatch]);

  return (
    <main data-testid="kobai-blossom-app" className="kobai tw:bg-primary-100 tw:text-secondary-400">
      <QueryClientProvider client={queryClient}>
        <FlagsProvider value={Features}>
          <StyledEngineProvider injectFirst>
            <Suspense fallback={<LoadingIndicator isLoading />}>
              <ErrorBoundary>
                <Root />
                {errorMessage && (
                  <ErrorModal errorText={errorMessage} onClose={handleErrorModalClose} />
                )}
                <AppWarningModalWithDetails />
              </ErrorBoundary>
            </Suspense>
          </StyledEngineProvider>
        </FlagsProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </main>
  );
}

export default App;
